"use client";
import { Textarea } from "@/components/ui/textarea";
import { IBlocks } from "@/types";
import React from "react";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function TextOptions({ block, blockUpdate, update }: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [content, setContent] = React.useState(
        block.options?.content || block.message
    );
    return (
        <>
            <Textarea
                className="resize-none"
                variant="card"
                value={content}
                placeholder="Write anything here"
                onChange={(e) => {
                    [
                        setContent(e.target.value),
                        blockUpdate({
                            ...block,
                            options: {
                                ...block.options,
                                content: e.target.value,
                            },
                        }),
                    ];
                }}
                onBlur={(e) => {
                    if (
                        e.target.value != oldBlock.options?.content ||
                        oldBlock.message
                    ) {
                        setOldBlock({
                            ...block,
                            options: {
                                ...block.options,
                                content: e.target.value,
                            },
                        });
                        update({
                            ...block,
                            options: {
                                ...block.options,
                                content: e.target.value,
                            },
                        });
                    }
                }}
            />
        </>
    );
}
